import { Injectable } from '@angular/core';
import { IndexedStorage, SyncMqtt, SyncService } from '@weavix/sync';
import { SyncHttp } from '@weavix/sync/src/sync.model';
import { HttpService } from '../http.service';
import { PubSubService } from '../pub-sub.service';
import { WebNativeStorage } from './web-native-storage';
import { RootStoreService } from './root-store-service';
import { environmentContext } from '../../../models-mobx/environment';
import { myUserId } from '../../../models-mobx/my-profile-store/my-profile-store';
import { TelemetryEvent } from '@weavix/telemetry';
import { Topic } from '@weavix/models/src/topic/topic';
import { TelemetryService } from '../telemetry.service';

@Injectable({
    providedIn: 'root',
})
export class SyncNgService {
    private constructor(
        httpService: HttpService,
        pubSubService: PubSubService,
        private readonly rootStoreService: RootStoreService,
        private readonly telemetryService: TelemetryService,
    ) {
        environmentContext.setDefault({ pubSubService });
        const syncMqtt: SyncMqtt = {
            subscribe: topic => pubSubService.subscribePassThrough(topic),
            // Web apps dont do simulcasting
            subscribeMultiple: topic => pubSubService.subscribePassThrough(topic),
            sendTelemetry: (name: TelemetryEvent, data) => pubSubService.publish(`user/${myUserId()}/telemetry` as Topic, [], [{ name, data }]),
        };
        const syncHttp: SyncHttp = {
            get: (path, params) => httpService.get(null, path, params),
            post: (path, body) => httpService.post(null, path, body),
        };
        const storage = new IndexedStorage<any>(new WebNativeStorage(`sync-${SyncService.version}`));
        SyncService.instance = new SyncService(syncHttp, syncMqtt, storage);
    }

    public async onLoggedIn(): Promise<void> {
        const wasLoggedIn = await SyncService.instance.loggedIn(); // set initial user
        await this.rootStoreService.getRootStore().wait(); // Wait for stores to actually load

        // Dependency free since 1993
        this.reportTelemetry(wasLoggedIn);

        if (!wasLoggedIn) {
            await SyncService.instance.waitForModules();
            await this.rootStoreService.getRootStore().wait(); // Wait for stores to actually load
        }
    }

    private async reportTelemetry(wasLoggedIn: boolean) {
        const start = Date.now();
        const metrics = await SyncService.instance.waitForModules('SyncNgService.reportTelemetry');

        await this.telemetryService.sendTelemetryImmediate(TelemetryEvent.SyncStartup, {
            platform: 'web',
            userId: myUserId(),
            duration: Date.now() - start,
            login: !wasLoggedIn,
            ...metrics,
        });
    }

    public async onLoggedOut(): Promise<void> {
        await SyncService.instance.loggedOut(true);
    }
}
